import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import * as opsApi from "@/features/ops/api";
import type { TdsHealth } from "@/features/ops/api";

export default function TdsHealthPage() {
  const [date, setDate] = useState("");
  const [data, setData] = useState<TdsHealth | null>(null);

  const load = async () => {
    try {
      setData(await opsApi.getTdsHealth(date || undefined));
    } catch (err) {
      toast.error(err instanceof Error ? err.message : "Could not load TDS health");
    }
  };

  useEffect(() => {
    void load();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="flex flex-col gap-4">
      <div className="flex flex-wrap items-end gap-2">
        <Input
          type="date"
          value={date}
          onChange={(e) => setDate(e.target.value)}
          className="w-48"
        />
        <Button onClick={load}>Load</Button>
      </div>
      {data?.note && (
        <Alert>
          <AlertTitle>Data source pending</AlertTitle>
          <AlertDescription>{data.note}</AlertDescription>
        </Alert>
      )}
      <Card className="gap-0 overflow-hidden p-0">
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Hour</TableHead>
              <TableHead>Requests</TableHead>
              <TableHead>Unknowns</TableHead>
              <TableHead>Errors (500)</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {data?.hours.map((h) => (
              <TableRow key={h.hour}>
                <TableCell>{String(h.hour).padStart(2, "0")}:00</TableCell>
                <TableCell>{h.requests}</TableCell>
                <TableCell>{h.unknowns}</TableCell>
                <TableCell>{h.errors}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Card>
    </div>
  );
}
